module.exports = __webpack_public_path__ + "static/media/faqBalance-es-ru.935bad17.vtt";